export const converters = {
  rvt: 'rvt-obv',
  rfa: 'rfa-obv',
  rte: 'rte-obv',
  nwd: 'nwd-obv',
  nwc: 'nwc-obv',
  dwg: 'dwg-obv',
  dxf: 'dxf-obv',
  imodel: 'imodel-obv',
  idgndb: 'idgndb-obv',
  dgn: 'dgn-obv',
  dwf: 'dwf-obv',
  dwfx: 'dwf-obv',
  skp: 'skp-obv',
  ifc: 'ifc-obv',
  obj: 'obj-obv',
  dae: 'dae-obv',
  '3ds': '3ds-obv',
  fbx: 'fbx-obv',
  step: 'step-obv',
  stl: 'stl-obv',
  ipt: 'ipt-obv',
  sldprt: 'sldprt-obv',
  CATPart: 'catpart-obv',
  rvm: 'rvm-obv',
  '3dm': '3dm-obv',
  pln: 'pln-obv',
  pla: 'pla-obv',
  bpn: 'bpn-obv',
  prj: 'prj-obv',
  dri: 'dri-obv',
  igs: 'igs-obv',
  iges: 'iges-obv',
  jt: 'jt-obv',
  lwo: 'lwo-obv',
  rcs: 'rcs-obv',
  rcp: 'rcp-obv',
  sat: 'sat-obv',
  wrl: 'wrl-obv',
  wrz: 'wrz-obv',
  gltf: 'gltf-obv',
  xgl: 'xgl-obv',
  ms3d: 'ms3d-obv',
  x3d: 'x3d-obv',
  doc: 'doc-obv',
  docx: 'docx-obv',
  xls: 'xls-obv',
  xlsx: 'xlsx-obv',
  csv: 'csv-obv',
  ppt: 'ppt-obv',
  pptx: 'pptx-obv',
  pdf: 'pdf-obv',
  mpp: 'mpp-obv',
  mpt: 'mpt-obv',
  vsd: 'vsd-obv',
  vsdx: 'vsdx-obv',
  vsdm: 'vsdm-obv',
  xml: 'xml-obv',
  htm: 'html-obv',
  html: 'html-obv',
  txt: 'txt-obv',
  xps: 'xps-obv',
  oxps: 'oxps-obv',
  jpg: 'jpg-obv',
  jpeg: 'jpeg-obv',
  bmp: 'bmp-obv',
  png: 'png-obv',
  gif: 'gif-obv',
  tiff: 'tiff-obv',
  t: 'pkpmt-obv',
  pkgb: 'pkgb-obv',
  obm: 'obm-obv',
  p3d:'p3d-obv',
  pmodel:'pmodel-obv'
}

// 二维文件格式
export const twoFileExt = ['dwg']

// 三维文件格式
export const threeFileExt = [
  'rvt',
  'obmx',
  '3dm',
  '3ds',
  'bdls',
  'dwfx',
  'ifc',
  'jws',
  'p3d',
  'sat',
  'skp',
  'pmodel'
]

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime (time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * parse to KB
 * @param {number} B
 */
export function toParseSizeByB (size, beforeUnit, afterUnit) {
  if (afterUnit) {
    // 换算指定单位
    if (beforeUnit === 'B' && afterUnit === 'KB') {
      return Math.ceil(size / 1024)
    } else if (beforeUnit === 'B' && afterUnit === 'GB') {
      return Math.round((size / Math.pow(1024, 3)) * 100) / 100
    }
  } else {
    // B=>KB=>MB=>GB
    if (Math.ceil(size / 1024) < 1024) {
      return Math.ceil(size / 1024) + 'KB'
    } else if (size / Math.pow(1024, 2) < 1024) {
      return Math.round((size / Math.pow(1024, 2)) * 100) / 100 + 'MB'
    } else {
      return Math.round((size / Math.pow(1024, 3)) * 100) / 100 + 'GB'
    }
  }
}

/**
 * 将普通列表转换为树结构的列表
 * @param {*} list 需要转换的数组
 * @param {*} id 唯一标识ID
 * @param {*} pField 父级ID的字段名  string
 */
export function listToTreeList (list, id, pField) {
  if (!list || !list.length) {
    return []
  }
  const treeListMap = {}
  for (const item of list) {
    treeListMap[item[id]] = item
  }
  for (let i = 0; i < list.length; i++) {
    if (list[i][pField] && treeListMap[list[i][pField]]) {
      if (!treeListMap[list[i][pField]].children) {
        treeListMap[list[i][pField]].children = []
      }
      treeListMap[list[i][pField]].children.push(list[i])
      list.splice(i, 1)
      i--
    }
  }
  return list
}

// 计算时间差
// createTime大于当前时间 时间戳
export function calcTimeDiffer (createTime, expiration) {
  console.log(createTime, expiration)
  if (expiration === -1) {
    return '永久有效'
  }

  let expirationTime = createTime + expiration * 60 * 60 * 24 * 1000

  var date2 = new Date() // 结束时间
  var date3 = expirationTime - date2.getTime() // 时间差秒

  // 计算出小时数
  var hours = date3 / (60 * 60 * 1000)

  if (hours < 24) {
    if (hours < 0) {
      return '链接已失效'
    } else if (hours < 1) {
      var minutes = Math.floor(hours * 60)
      return minutes + '分钟后'
    } else {
      return Math.floor(hours) + '小时后'
    }
  } else {
    // 计算出相差天数
    var days = Math.floor(date3 / (24 * 3600 * 1000))
    return days + '天后'
  }
}

//防抖函数
export function mydebounce(func, delay) { // func 函数 delay间隔时间
  let timer
  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export const compressFile = [
  0x50,
  0x4b,
  0x03,
  0x04,
  0x14,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x80,
  0x8d,
  0xe7,
  0x52,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x0b,
  0x00,
  0x00,
  0x00,
  0x2e,
  0x61,
  0x6e,
  0x63,
  0x68,
  0x6f,
  0x72,
  0x2e,
  0x74,
  0x78,
  0x74,
  0x50,
  0x4b,
  0x01,
  0x02,
  0x14,
  0x00,
  0x14,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x80,
  0x8d,
  0xe7,
  0x52,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x0b,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x20,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00,
  0x2e,
  0x61,
  0x6e,
  0x63,
  0x68,
  0x6f,
  0x72,
  0x2e,
  0x74,
  0x78,
  0x74,
  0x50,
  0x4b,
  0x05,
  0x06,
  0x00,
  0x00,
  0x00,
  0x00,
  0x01,
  0x00,
  0x01,
  0x00,
  0x39,
  0x00,
  0x00,
  0x00,
  0x29,
  0x00,
  0x00,
  0x00,
  0x00,
  0x00
]



// WEBPACK FOOTER //
// ./src/js/common.js